import { Form } from 'formik'
import styled, { css } from 'styled-components'

import { Button } from '@src/components/Button'
import { CancelSVG } from '@src/components/SVGS/CancelSVG'
import { breakpoints } from '../../../../constants/breakpoints'

export const Container = styled.div<{ discountOpen: boolean }>`
  padding: 0px;
`

export const ApplyButton = styled(Button)`
  max-width: 104px;
  font-size: 14px;
  height: 56px;
  margin-left: 16px;
`

export const Title = styled.p`
  font-size: 14px;
  text-align: right;
  text-decoration-line: underline;
  color: #2e3333;

  &:hover {
    text-decoration: none;
  }
`

export const SpaceBetweenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ActiveDiscountContainer = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  align-items: center;
  height: 32px;
  font-size: 14px;
`

export const ActiveDiscount = styled.p`
  padding: 0 4px;
  padding-left: 4px;
`

export const ActiveDiscountName = styled(ActiveDiscount)`
  padding-left: 4px;
  color: ${({ theme }) => theme.colors.discount};
  font-weight: 700;
`

export const DiscountForm = styled(Form)`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const ClearButton = styled(CancelSVG)`
  cursor: pointer;
  margin-left: 4px;

  &:hover {
    opacity: 0.8;
  }
`

export const SpaceBetweenButton = styled.button<{ discountOpen: boolean }>`
  border: none;
  background-color: transparent;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  padding: 0;
  height: 32px;
  margin-left: 0px;
  @media (max-width: ${breakpoints.largeMobile}px) {
    margin-left: 44px;
  }

  ${({ discountOpen }) =>
    discountOpen &&
    css`
      margin-bottom: 8px;
    `}
`

export const VoucherWarningContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 12px;
`

export const VoucherWarning = styled.p`
  font-size: 12px;
`
